module.exports = {
  states: {
    token: window.localStorage.getItem('token') || '',
    permissions: window.localStorage.getItem('permissions') || []
  },
  mutations: {
    setToken (state, token) {
      state.token = token
      console.log('vuex', token)
      window.localStorage.setItem('token', token)
    },
    removeToken (state) {
      state.token = ''
      window.localStorage.removeItem('token')
    },
    setPermissions (state, permissions) {
      state.permissions = permissions
      // console.log(permissions, 'permissions')
      window.localStorage.setItem('permissions', permissions)
    },
    removePermissions (state) {
      state.permissions = ''
      window.localStorage.removeItem('permissions')
    }
  },
  actions: {},
  getters: {},
  namespaced: true
}
